export default (ctx, html) => html`
    <slot></slot>
`;
